module.exports = __webpack_public_path__ + "static/media/avatar.dd671551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/avatar.svg
// module id = 1145
// module chunks = 0